import { EmptyState } from '@common/components/EmptyState';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import routes from '@routes';
import { MaterialIcon } from '@common/ui/MaterialIcon';

export default function AccessSessionGroupListEmptyState() {
  return (
    <EmptyState
      title="No active access yet"
      imgSrc="/static/illustrations/not-found.svg"
      body="Create a new request and start using access!"
      action={
        <Button
          color="primary"
          component={Link}
          variant="contained"
          to={routes.NewRequest.path}
          startIcon={<MaterialIcon symbol="add" />}
        >
          New Access Request
        </Button>
      }
    />
  );
}
